import React, { useEffect, useState } from "react";
import moment from "moment";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { toast } from "react-toastify";

import {
  userActivity as fetchUserActivity,
} from "../../redux/slices/dashboard";

// Adjust the Loader import path according to your project structure
import Loader from "../../common/Loader";

const UserActivity = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [userActivityData, setUserActivityData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit] = useState(10); // use 5 as per your API example
  const [pageCount, setPageCount] = useState(0);

  const getUserActivity = () => {
    setLoading(true);
    const params = { user_id: id, page, limit };

    dispatch(
      fetchUserActivity({
        ...params,
        cb(res) {
          setLoading(false);
          if (res?.status === 200) {
            const data = res?.data?.payload?.data || [];
            const pagination = res?.data?.payload?.pagination || {};
            setUserActivityData(data);
            setPageCount(pagination.totalPages || 0);
          } else {
            toast.error("Something went wrong");
          }
        },
      })
    );
  };

  const handlePageClick = (event) => {
    setPage(event.selected + 1); // ReactPaginate is 0-based
  };

  useEffect(() => {
    getUserActivity();
  }, [page, id]);

  return (
    <div className="user-activity">
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="mainHead32">User Activity</h1>
              </div>
            </div>
          </div>
        </div>

        <div className="recentUserSec">
          {loading && <Loader />}

          <div className="table-responsive recentTable userRecentTable">
            <table className="table table-dark m-0">
              <thead>
                <tr className="recentRow">
                  <th scope="col" className="recentHead">SR. NO.</th>
                  <th scope="col" className="recentHead">Activity</th>
                  <th scope="col" className="recentHead">Time</th>
                </tr>
              </thead>

              <tbody>
                {userActivityData.length > 0 ? (
                  userActivityData.map((data, idx) => {
                    const index = idx + 1 + (page - 1) * limit;
                    return (
                      <tr key={data.id || idx}>
                        <td className="recentSubHead">
                          <h4 className="tableSubText">{index}</h4>
                        </td>
                        <td className="recentSubHead">
                          <div className="nameProfile">
                            <h4 className="tableSubText">{data?.title}</h4>
                          </div>
                        </td>
                        <td className="recentSubHead">
                          <div className="nameProfile">
                            <h4 className="tableSubText">
                              {moment(data?.created_at).format("YYYY-MM-DD HH:mm:ss")}
                            </h4>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center text-white py-4">
                      No User Activity Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {userActivityData.length > 0 && (
            <div className="col-12">
              <div className="customPagination mt-4">
                <ReactPaginate
                  className="pagination"
                  nextLabel={
                    <span>
                      Next <span className="double-arrow" />
                    </span>
                  }
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={5}
                  marginPagesDisplayed={2}
                  pageCount={pageCount}
                  forcePage={page - 1}
                  previousLabel={
                    <span>
                      <span className="double-arrow h5" /> Prev
                    </span>
                  }
                  renderOnZeroPageCount={null}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserActivity;